<script lang="ts">
					import { defineComponent } from 'vue'
					export default defineComponent({
						name: "undefined"
					})
				</script><template>
	<el-config-provider :locale="zhCn">
		<router-view />
		<OssArchiveRestoreHost />
	</el-config-provider>
</template>

<script lang="ts" setup>
import { ElConfigProvider } from "element-plus";
import zhCn from "element-plus/lib/locale/lang/zh-cn";
import OssArchiveRestoreHost from "/$/common/components/oss-archive-restore-host.vue";
</script>
<style lang="scss" src="./assets/css/index.scss">

</style>
